import React from 'react';
import { View, ViewProps } from 'react-native';

interface LinearGradientProps extends ViewProps {
  colors?: string[];
  start?: { x: number; y: number };
  end?: { x: number; y: number };
  locations?: number[];
  children?: React.ReactNode;
}

const LinearGradient = React.forwardRef<any, LinearGradientProps>(
  ({ colors = [], start, end, locations, style, children, ...props }, ref) => {
    // Create a CSS gradient string from the colors
    let gradientString = 'to right';
    if (start && end) {
      // Convert start/end points to CSS gradient angle
      const dx = (end.x || 1) - (start.x || 0);
      const dy = (end.y || 1) - (start.y || 0);
      const angle = Math.atan2(dy, dx) * (180 / Math.PI);
      gradientString = `${angle}deg`;
    }

    const colorStops = colors
      .map((color, index) => {
        if (locations && locations[index] !== undefined) {
          return `${color} ${locations[index] * 100}%`;
        }
        return color;
      })
      .join(', ');

    const backgroundImage = `linear-gradient(${gradientString}, ${colorStops})`;

    return (
      <View
        ref={ref}
        style={[
          style as any,
          {
            background: backgroundImage,
          },
        ]}
        {...props}
      >
        {children}
      </View>
    );
  }
);

LinearGradient.displayName = 'LinearGradient';

export default LinearGradient;
